var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.111,
    height: 19.111,
    viewBox: "0 0 19.111 19.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M13.938,0H5.173A5.179,5.179,0,0,0,0,5.173v8.765a5.179,5.179,0,0,0,5.173,5.173h8.765a5.179,5.179,0,0,0,5.173-5.173V5.173A5.179,5.179,0,0,0,13.938,0ZM9.556,14.781a5.226,5.226,0,1,1,5.226-5.226A5.232,5.232,0,0,1,9.556,14.781Zm5.351-9.219a1.544,1.544,0,1,1,1.544-1.544A1.546,1.546,0,0,1,14.906,5.562Zm0,0",
    transform: "translate(0 0)",
    fill: "#5861ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M150.125,146.02a4.105,4.105,0,1,0,4.105,4.105A4.11,4.11,0,0,0,150.125,146.02Zm0,0",
    transform: "translate(-140.569 -140.569)",
    fill: "#5861ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M388.416,96.3a.424.424,0,1,0,.424.424A.424.424,0,0,0,388.416,96.3Zm0,0",
    transform: "translate(-373.51 -92.706)",
    fill: "#5861ae"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.330ceb5e2b88df549b643a303f455f4e.svg";
export { ForwardRef as ReactComponent };